import { ArrowRight, Clock } from "lucide-react";
import { Link } from "react-router";

import { GUIDES, type Guide } from "@/lib/guides";

/**
 * The guides, as a list. Each is a page of its own; the front page is the first of them.
 * Short on purpose: a reader who is here wants to pick, not to read about picking.
 */
export function GuidelinesRoute() {
  return (
    <div className="mx-auto max-w-3xl space-y-8">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight">Guides</h1>
        <p className="text-muted-foreground text-sm leading-6">
          Read in order the first time. After that, each stands on its own.
        </p>
      </div>
      <ol className="space-y-3">
        {GUIDES.map((guide, index) => (
          <li key={guide.to}>
            <GuideCard guide={guide} index={index + 1} />
          </li>
        ))}
      </ol>
    </div>
  );
}

export function GuideCard({ guide, index }: { guide: Guide; index?: number }) {
  const Icon = guide.icon;
  return (
    <Link
      to={guide.to}
      className="group bg-card hover:bg-muted/60 flex items-start gap-4 rounded-lg border p-4 transition-colors"
    >
      <span className="bg-primary/10 text-primary grid size-10 shrink-0 place-items-center rounded-md">
        <Icon className="size-5" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          {index !== undefined ? (
            <span className="text-muted-foreground font-mono text-xs tabular-nums">{index}</span>
          ) : null}
          <span className="font-semibold">{guide.title}</span>
          <ArrowRight
            className="size-3.5 transition-transform group-hover:translate-x-0.5"
            aria-hidden
          />
          {guide.minutes ? (
            <span className="text-muted-foreground ml-auto inline-flex items-center gap-1 text-xs">
              <Clock className="size-3" aria-hidden />
              {guide.minutes} min
            </span>
          ) : null}
        </span>
        <span className="text-muted-foreground mt-1 block text-sm leading-6">{guide.text}</span>
      </span>
    </Link>
  );
}
